import { render, staticRenderFns } from "./BadgeAssertionModal.vue?vue&type=template&id=3fd98dd8"
import script from "./BadgeAssertionModal.vue?vue&type=script&lang=js"
export * from "./BadgeAssertionModal.vue?vue&type=script&lang=js"
import style0 from "./BadgeAssertionModal.vue?vue&type=style&index=0&id=3fd98dd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports